<emma-text-check-modal
    *ngIf="showCheckModal"
    [items]="autocompleteItems"
    [type]="autocompleteCheckItemsModalType"
    [text]="value"
    (close)="onCancelCheckItems()"
    [icon]="autocompleteCheckIcon"
>
</emma-text-check-modal>
<div class="emma-textarea--header">
    <ng-template #defaultHeader>
        <label *ngIf="label" [class]="disabled ? 'disabled' : ''">
            {{ label }}
            <emma-info-icon
                [helpText]="helpText"
                [helpLink]="helpLink"
                [helpLinkLabel]="helpLinkLabel"
            ></emma-info-icon>
        </label>
        <span *ngIf="label && required && !disabled" class="required-label" i18n>Obligatorio</span>
        <span
            *ngIf="showCharCounter"
            [ngClass]="{
                'char-counter': true,
                'char-counter__overflow': getCharCounterLength() > charCounterMaxLength,
                'char-counter__limit':
                    getCharCounterLength() > charCounterMaxLength - 10 &&
                    getCharCounterLength() <= charCounterMaxLength
            }"
        >
            <span class="char-counter__number">{{ getCharCounterLength() }}</span>
            / {{ charCounterMaxLength }}
            <span class="char-counter__units" i18n>caracteres</span>
        </span>
        <div class="d-flex align-items-center ms-auto">
            <button
                *ngIf="autocompleteCheckItems"
                class="emma-textarea--autocomplete-checker"
                emmaButton
                sizeButton="sm"
                [isCircle]="true"
                [noBg]="true"
                [hasIcon]="true"
                [onlyIcon]="true"
                (click)="onCheckItems()"
                [ngbPopover]="autocompleteCheckPopoverMsg"
                placement="top"
                triggers="hover"
                container="body"
                i18n-ngbPopover
            >
                <i class="la {{ autocompleteCheckIcon }}" aria-hidden="true"></i>
            </button>
            <emma-dropdown
                *ngIf="autocompleteButtonLabel.length"
                class="emma-textarea--autocomplete-dropdown"
                color="link-emmadarkblue"
                [items]="autocompleteItems"
                [buttonLabel]="autocompleteButtonLabel"
                [buttonIcon]="autocompleteButtonIcon"
                [groupBy]="autocompleteGroupBy"
                [searchable]="true"
                [disabled]="disabled"
                ($select)="onSelectAutocompleteTag($event)"
            ></emma-dropdown>
        </div>
    </ng-template>
    <ng-template
        [ngTemplateOutlet]="headerTemplate ? headerTemplate : defaultHeader"
        [ngTemplateOutletContext]="{
            helpText: helpText,
            helpLink: helpLink,
            helpLinkLabel: helpLinkLabel,
            autocompleteButtonIcon: autocompleteButtonIcon,
            autocompleteItems: autocompleteItems,
            autocompleteButtonLabel: autocompleteButtonLabel,
            disabled: disabled,
            required: required,
            readonly: readonly,
            showCharCounter: showCharCounter,
            charCounterMaxLength: charCounterMaxLength,
            value: value,
            label: label
        }"
    ></ng-template>
</div>
<div [ngClass]="{ 'emma-textarea--main': true, 'm-input': true, 'emma-textarea__primary': true }">
    <div
        #highlight
        [ngClass]="{
            'emma-textarea--highlight': true,
            'm-textarea--monospace': useMonospaceFont,
            'form-control': true
        }"
    >
        <ng-template
            [ngTemplateOutlet]="highlightTemplate"
            [ngTemplateOutletContext]="{
                autocompleteItems: autocompleteItems,
                disabled: disabled,
                readonly: readonly,
                showCharCounter: showCharCounter,
                charCounterMaxLength: charCounterMaxLength,
                value: value,
                label: label
            }"
        ></ng-template>
    </div>
    <textarea
        #textarea
        spellcheck="false"
        [ngClass]="{ 'form-control': true, 'm-textarea--monospace': useMonospaceFont }"
        [rows]="linesToShow"
        [(ngModel)]="value"
        (blur)="onBlur()"
        [required]="!!required"
        [readOnly]="readonly"
        [disabled]="disabled"
    ></textarea>
</div>
<div *ngIf="footerTemplate" class="emma-textarea--footer">
    <ng-template
        [ngTemplateOutlet]="footerTemplate"
        [ngTemplateOutletContext]="{
            helpText: helpText,
            helpLink: helpLink,
            helpLinkLabel: helpLinkLabel,
            autocompleteButtonIcon: autocompleteButtonIcon,
            autocompleteItems: autocompleteItems,
            autocompleteButtonLabel: autocompleteButtonLabel,
            disabled: disabled,
            required: required,
            readonly: readonly,
            showCharCounter: showCharCounter,
            charCounterMaxLength: charCounterMaxLength,
            value: value,
            label: label
        }"
    ></ng-template>
</div>
